import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  FiShield,
  FiArrowRight,
  FiCheckCircle,
  FiChevronDown,
  FiMonitor,
  FiPhoneCall,
  FiMessageSquare,
} from "react-icons/fi";
import { FaGooglePlay, FaApple } from "react-icons/fa";
import {
  LuBuilding2,
  LuCalendarCheck,
  LuShieldCheck,
  LuCreditCard,
  LuFileText,
  LuUsers,
} from "react-icons/lu";
import { BsGraphUpArrow } from "react-icons/bs";
import { useForm } from "react-hook-form";
import { FiUser, FiMail, FiPhone, FiUsers } from "react-icons/fi";
import { SlCalender } from "react-icons/sl";
import { TypeAnimation } from "react-type-animation";
import Swal from "sweetalert2";
import axios from "axios";
import { HiH2 } from "react-icons/hi2";
import { PiTagSimple } from "react-icons/pi";

const stores = [
  {
    title: "Google Play",
    icon: <FaGooglePlay size={22} />,
    link: "#",
  },
  {
    title: "App Store",
    icon: <FaApple size={22} />,
    link: "#",
  },
];
const employeeOptions = ["1-10", "11-25", "26-50", "51-100", "100+"];

const demoOptions = [
  "All in One",
  "HRMS",
  "Project",
  "Payroll",
  "ATS",
  "EMS",
  "Performance",
  "Field Force",
];

const HeroForm = () => {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    watch,
    reset,
    setValue,
    formState: { errors },
  } = useForm();
  const [loading, setLoading] = useState(false);
  const selectedEmployee = watch("employees");
  const selecteddemorequest = watch("demorequest");
  const onSubmit = async (data) => {
    try {
      setLoading(true);

      const payload = {
        fullName: data.fullName,
        phone: data.phone,
        email: data.email,
        employees: data.employees,
        demorequest: data.demorequest,
      };

      const response = await axios.post(
        `${import.meta.env.VITE_APIBASE_URL}` + "/payslips/home-demo",
        payload,
      );

      if (response.data.success) {
        // toast.success("Message sent successfully.");
        // Swal.fire({
        //   icon: "success",
        //   title: "Request Submitted",
        //   text: response.data.message,
        //   confirmButtonColor: "#10324F",
        // });
        navigate("/thank-you");
        reset();

        setValue("phone", "");
      } else {
        Swal.fire({
          icon: "error",
          title: "Something went wrong",
          text: "Please try again later.",
          confirmButtonColor: "#10324F",
        });
      }
    } catch (err) {
      console.error("Error submitting form:", err);
      Swal.fire({
        icon: "error",
        title: "Something went wrong",
        text: err || "Please try again later.",
        confirmButtonColor: "#10324F",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-110 w-full  rounded-xl border border-white p-6">
      <h2 className="text-2xl font-bold text-center text-[#10324F]">
        Try Waggex for Free
      </h2>

      {/* <p className="text-center text-[#10324F] mt-2">No credit card required</p> */}

      <form onSubmit={handleSubmit(onSubmit)} className="mt-8 space-y-4">
        {/* Name */}
        <div>
          <div className="relative">
            <FiUser
              size={20}
              className="absolute left-5 top-1/2 -mt-2.5 text-[#10324F]"
            />

            <input
              type="text"
              placeholder="Full Name"
              className={`w-full h-10 rounded-xl border-0 bg-white   placeholder:text-gray-700 pl-14 pr-4 outline-none transition focus:ring-0
              ${errors.fullName ? "border-red-500" : "border-gray-200"}`}
              {...register("fullName", {
                required: "Full Name is required",
              })}
            />
          </div>

          {errors.fullName && (
            <p className="text-red-500 text-sm mt-1">
              {errors.fullName.message}
            </p>
          )}
        </div>
        {/* Email */}
        <div>
          <div className="relative">
            <FiMail
              size={20}
              className="absolute left-5 top-1/2 -mt-2.5 text-[#10324F]"
            />

            <input
              type="email"
              placeholder="Work Email"
              className={`w-full h-10 rounded-xl border-0 bg-white  placeholder:text-gray-700 pl-14 pr-4 outline-none transition focus:ring-0 focus:border-0
              ${errors.email ? "border-red-500" : "border-gray-200"}`}
              {...register("email", {
                required: "Email is required",
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Enter valid email",
                },
              })}
            />
          </div>

          {errors.email && (
            <p className="text-red-500 text-sm mt-1">{errors.email.message}</p>
          )}
        </div>
        {/* Phone */}
        <div>
          <div
            className={`flex h-10 rounded-xl border overflow-hidden bg-white focus:border-white
            ${errors.phone ? "border-0" : "border-gray-200 focus:ring-0"}`}
          >
            <div className="px-4 flex items-center border-r border-gray-400 text-sm text-[#10324F] font-semibold">
              +91
            </div>
            {/* 
            <div className="px-4 flex items-center">
              <FiPhone size={18} className="text-gray-400" />
            </div> */}

            <input
              type="text"
              placeholder="Phone Number"
              maxLength={10}
              inputMode="numeric"
              className="flex-1 outline-none pr-4 pl-2 placeholder:text-gray-700"
              {...register("phone", {
                required: "Phone Number is required",
                pattern: {
                  value: /^[0-9]{10}$/,
                  message: "Enter valid phone number",
                },
              })}
              onInput={(e) => {
                e.target.value = e.target.value.replace(/\D/g, "");
              }}
            />
          </div>

          {errors.phone && (
            <p className="text-red-500 text-sm mt-1">{errors.phone.message}</p>
          )}
        </div>
        {/* Employee */}
        <div>
          <div className="relative">
            <label htmlFor="employees" className="sr-only">
              Employee
            </label>
            <FiUsers
              size={20}
              className="absolute left-5 top-1/2 -mt-2.5 text-[#10324F]"
            />
            <select
              id="employees"
              className={`w-full h-10 rounded-xl border bg-white placeholder:text-gray-700 pl-14 pr-4 outline-none appearance-none focus:ring-0 focus:border-white transition 
    ${selectedEmployee ? "text-[#10324F]" : "text-gray-700"}
    ${
      errors.employees ? "border-0" : "border-gray-200 focus:border-[#10324F]"
    }`}
              {...register("employees", {
                required: "Employee Size is required",
              })}
            >
              <option value="" className="text-gray-700">
                Employee Size
              </option>

              {employeeOptions.map((item) => (
                <option key={item} value={item} className="text-[#10324F]">
                  {item}
                </option>
              ))}
            </select>
            <FiChevronDown
              size={18}
              className="pointer-events-none absolute right-4 top-1/2 -mt-2.5 text-[#10324F]"
            />
          </div>

          {errors.employees && (
            <p className="text-red-500 text-sm mt-1">
              {errors.employees.message}
            </p>
          )}
        </div>

        <div>
          <div className="relative">
            <label htmlFor="demorequest" className="sr-only">
              Book Demo
            </label>
            <FiMessageSquare
              size={20}
              className="absolute left-5 top-1/2 -mt-2.5 text-[#10324F]"
            />
            <select
              id="demorequest"
              className={`w-full h-10 rounded-xl border bg-white placeholder:text-gray-700 pl-14 pr-4 outline-none appearance-none focus:ring-0 focus:border-white transition 
    ${selecteddemorequest ? "text-[#10324F]" : "text-gray-700"}
    ${
      errors.demorequest ? "border-0" : "border-gray-200 focus:border-[#10324F]"
    }`}
              {...register("demorequest", {
                required: "Demo request  is required",
              })}
            >
              <option value="" className="text-gray-700">
                Book demo
              </option>

              {demoOptions.map((item) => (
                <option key={item} value={item} className="text-[#10324F]">
                  {item}
                </option>
              ))}
            </select>
            <FiChevronDown
              size={18}
              className="pointer-events-none absolute right-4 top-1/2 -mt-2.5 text-[#10324F]"
            />
          </div>

          {errors.demorequest && (
            <p className="text-red-500 text-sm mt-1">
              {errors.demorequest.message}
            </p>
          )}
        </div>
        {/* Button */}
        <button
          type="submit"
          className="w-full h-10 rounded-xl bg-[#10324F] text-white font-normal text-lg hover:opacity-95 transition"
        >
          Try Free Demo
        </button>
        {/* By continuing, you agree to our Terms & Privacy Policy. */}
        {/* <p className="text-center text-xs text-[#10324F] leading-6">
          By continuing, you agree to our{" "}
          <Link
            to="/terms-conditions"
            className="text-[#10324F] font-semibold hover:underline"
          >
            Terms
          </Link>
          <br />
          and{" "}
          <Link
            to="/privacy-policy"
            className="text-[#10324F] font-semibold hover:underline"
          >
            Privacy Policy
          </Link>
        </p> */}
        <p className="text-center text-xs text-[#10324F] leading-6 whitespace-normal lg:whitespace-nowrap">
          By continuing, you agree to our{" "}
          <Link
            to="/terms-conditions"
            className="font-semibold hover:underline"
          >
            Terms
          </Link>{" "}
          and{" "}
          <Link to="/privacy-policy" className="font-semibold hover:underline">
            Privacy Policy
          </Link>
        </p>
        {/* Bottom Cards */}
        {/* <div className="grid grid-cols-3 gap-3 pt-3">
          <div className="border rounded-xl p-2 text-center border-gray-200 text-[#10324F] bg-white">
            <LuCreditCard size={26} className="mx-auto text-[#10324F] mt-2" />

            <p className="text-xs font-semibold mt-3 leading-5">
              No Credit Card Required
            </p>
          </div>

          <div className="border rounded-xl p-2 text-center border-gray-200 text-[#10324F] bg-white">
            <LuFileText size={26} className="mx-auto text-[#10324F] mt-2" />

            <p className="text-xs font-semibold mt-3 leading-5">
              Try Free for 5 Employees
            </p>
          </div>

          <div className="border rounded-xl p-2 text-center border-gray-200 text-[#10324F] bg-white">
            <LuUsers size={26} className="mx-auto text-[#10324F] mt-2" />

            <p className="text-xs font-semibold mt-3 leading-5">
              Loved by 100+ Companies
            </p>
          </div>
        </div> */}
      </form>
    </div>
  );
};

const MainHeroSection = () => {
  const inputClass =
    "w-full h-11 rounded-xl border border-gray-200 pl-11 pr-4 outline-none bg-white focus:border-[#10324F] transition";
  return (
    <section className="relative overflow-hidden bg-[#d3e0eb] px-6 py-10">
      {/* Background */}

      <div className="relative max-w-6xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[54%_44%] gap-6 items-center">
          {/* LEFT CONTENT */}

          <div className="relative z-20 ">
            {/* Heading */}
            <div className="inline-flex items-center gap-2 rounded-xl bg-[#EAF2FF] px-4 py-2">
              <PiTagSimple
                className="text-[#10324F] text-lg -rotate-35"
                strokeWidth={2.2}
              />

              <span className="text-[#10324F] font-normal text-sm tracking-wide">
                Starting at ₹2 per employee/day
              </span>
            </div>
            <h1 className="text-xl md:text-2xl xl:text-4xl font-extrabold leading-tight text-[#10324F] mt-6">
              START WITH WAGGEX
              <br />
              PAYROLL SOFTWARE
              <br />
              <span className="text-[#1D4E89] text-sm font-normal lg:text-3xl">
                & {""}
                <TypeAnimation
                  sequence={[
                    "Eliminate 80% of HR work",
                    2000,
                    "Try Free for 5 Employees",
                    2000,
                    "Automate payroll in minutes",
                    2000,
                    "Manage attendance with payroll",
                    2000,
                    "Reduce manual HR work",
                    2000,
                    "Process salaries faster",
                    2000,
                    "Simplify payroll, attendance & compliance",
                    2000,
                  ]}
                  speed={50}
                  repeat={Infinity}
                />
              </span>
            </h1>

            {/* Description */}
            <div className="mt-6 max-w-2xl min-h-24 sm:min-h-16">
              <p className=" text-[#10324F] leading-8 text-lg">
                Manage employee attendance, payroll, records & compliance,
                <br /> All in one HRMS platform
              </p>
            </div>

            {/* Price */}

            {/* <div className="mt-8">
              <h2 className="text-xl font-bold text-[#10324F]">
                Get started for just{" "}
                <span className="text-[#10324F]">₹2 per employee/day</span>
              </h2>
            </div> */}
            {/* <div className="text-left max-w-2xl mx-auto mt-6">
              <h2 className="text-lg font-normal text-[#10324F]">
                Download the Waggex Company & Staff Apps
              </h2>

              <div className="mt-4 flex flex-wrap items-start  gap-3 text-lg md:text-xl">
                <span className="mt-2 text-left text-sm font-normal text-[#10324F]">
                  Available On:
                </span>
                <a href="#" className="group">
                  <div
                    className="
                    w-10 h-10
                    rounded-md
                    bg-[#eef3f7]
                    border border-white/70
                    flex items-center justify-center
                    text-[#10324F]
                  "
                  >
                    {" "}
                    <FaApple className="text-black text-2xl" />
                  </div>
                </a>
                <a href="#" className="group">
                  <div
                    className="
                    w-10 h-10
                    rounded-md
                    bg-[#eef3f7]
                    border border-white/70
                    flex items-center justify-center
                    text-[#10324F]
                  "
                  >
                    {" "}
                    <FaGooglePlay className="text-[#10324F] text-xl" />
                  </div>
                </a>
              </div>
            </div> */}
            {/* Buttons */}

            <div className="flex flex-col sm:flex-row gap-5 mt-10">
              <Link
                to="https://app.waggex.com/signup"
                className="h-10 px-14 rounded-xl bg-[#10324F] hover:bg-[#0B2844] transition-all text-white font-normal flex items-center justify-center gap-3 shadow-lg"
              >
                Start Free Today
                <FiArrowRight size={20} />
              </Link>
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="relative flex justify-center sm:justify-end items-center">
            <HeroForm />
          </div>
        </div>
      </div>
    </section>
  );
};

export default MainHeroSection;
